import { render } from "./ReportSuggest.vue?vue&type=template&id=1620e1cc&scoped=true"
import script from "./ReportSuggest.vue?vue&type=script&lang=js"
export * from "./ReportSuggest.vue?vue&type=script&lang=js"

import "./ReportSuggest.vue?vue&type=style&index=0&id=1620e1cc&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1620e1cc"]])

export default __exports__